// ABOUTME: Bordered card used as the container of every job overview section.
// ABOUTME: Extracts the Paper + bordered Box pattern the overview repeated inline.

import { Box, Paper, Stack, Typography, useTheme } from '@ds/coolshop';
import { ReactNode } from 'react';

interface ISectionCardProps {
    title: ReactNode;
    /** Defaults to the neutral grey border used by informational sections. */
    borderColor?: string;
    action?: ReactNode;
    children: ReactNode;
}

export function SectionCard(props: Readonly<ISectionCardProps>) {
    const { title, borderColor, action, children } = props;
    const theme = useTheme();

    return (
        <Paper elevation={0}>
            <Box
                border={`2px solid ${borderColor ?? theme.palette.grey[300]}`}
                borderRadius={1}
                p={1.5}
            >
                <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="subtitle2" color="text.secondary">
                        <b>{title}</b>
                    </Typography>
                    {action}
                </Box>
                <Stack gap={1}>{children}</Stack>
            </Box>
        </Paper>
    );
}
